<template>
    <shinsei-menu />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ShinseiMenu from '@/components/shinsei/Menu.vue';

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'shinsei-menu': ShinseiMenu
    }
})
</script>
